import { useEffect, useState } from "react";
import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";

import ProductsTable from "../components/ProductsTable";

import { DataTableLoadingSkeleton } from "../../../shared/components/DataTable";
import ProductForm from "../components/ProductForm";
import Modal from "../../../shared/components/Modal";
import Button from "../../../shared/components/Button";
import {
  addProduct,
  getAllProducts,
  getProductById,
} from "../../../../../services/Production/productClient";

export default function ProductsListPage() {
  const [products, setProducts] = useState([]);
  // const {
  //   data,
  //   error,
  //   isLoading: productsLoading,
  //   refetch,
  // } = useQuery(["Products"], getAllProducts);

  const formId = "add-product-form";

  const [addProductForm, setAddProductForm] = useState(false);
  useEffect(() => {
    getAllProducts().then((response) => {
      setProducts(response.data)
    })


  }, []);

  const {
    mutate,
    isLoading: addProductLoading,
    error: addProductError,
    isSuccess: productAdded,
  } = useMutation({ mutationFn: addProduct });

  const onSubmit = (data) => {
    mutate(data);
  };

  useEffect(() => {
    if (productAdded) {
      toast("Produit ajouté", { type: "success" });
      setAddProductForm(false);
      // refetch();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productAdded]);

  const [productDetailsForm, setProductDetailsForm] = useState(false);

  const [productId, setProductId] = useState(null);
  const { data: productDetails, isLoading: productDetailsLoading } = useQuery(
    ["Products", productId],
    getProductById
  );

  if (addProductError) toast("Error", { type: "error" });

  // if (productsLoading) return <DataTableLoadingSkeleton />;
  // if (error) return <h1 style={{ color: "red" }}>{error.message}</h1>;
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}><div className="content-header">
      {/*Product details */}
      {/* <Modal
        isShown={productDetailsForm}
        onClose={() => setProductDetailsForm(false)}
      >
        <Modal.Header>
          <Modal.Title title="Ajouter Produit" />
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: "70vh", overflow: "auto" }}>
            {productDetailsLoading && "Loading ...."}
            {productDetails && (
              <ProductForm
                defaultValues={productDetails || undefined}
                formId={"edit"}
                onSubmit={onSubmit}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            position: "absolute",
            background: "white",
            bottom: -50,
            width: "100%",
          }}
        >
          <Button isLoading={addProductLoading} type="submit" form={"edit"}>
            Sauvegarder
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* Add product */}
      {/* <Modal isShown={addProductForm} onClose={() => setAddProductForm(false)}>
        <Modal.Header>
          <Modal.Title title="Ajouter Produit" />
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: "70vh", overflow: "auto" }}>
            <ProductForm formId={formId} onSubmit={onSubmit} />
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            position: "absolute",
            background: "white",
            bottom: -50,
            width: "100%",
          }}
        >
          <Button isLoading={addProductLoading} type="submit" form={formId}>
            Add Product
          </Button>
        </Modal.Footer>
      </Modal> */}

      {products &&
        <ProductsTable
          products={products}
          onProductClick={(id) => () => {
            setProductDetailsForm(true);
            setProductId(id);
          }}
          onAddClick={() => setAddProductForm(true)}
        />}
    </div>
    </div>
  );
}
